/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const ChipSelectorPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * actions e.g. for analytics tracking
   */
  actions: PropTypes.object.isRequired,

  /**
   * The callback to call on item select
   */
  onSelect: PropTypes.func.isRequired,

  /**
   * The items
   */
  chips: PropTypes.array,
};

export default ChipSelectorPropTypes;
